'use strict';
const { map, data } = require('jquery');
var $ = require('jquery');

/**
 * Element for loading animation
 */
const LOADER = '<div class="loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>';

/**
 * On initial page load
 */

SVGElement.prototype.getTransformToElement = SVGElement.prototype.getTransformToElement || function (toElement) {
    return toElement.getScreenCTM().inverse().multiply(this.getScreenCTM());
};

$(function () {

    if ($('body').hasClass('page-template-archive-gw_ahola_staff')) {

        // ## ## ## ## ##  ## ## ## //
        //          HELPERS         //
        // ## ## ## ## ##  ## ## ## //

        /**
         * Spawn the loading animation
         */
        function spawnLoader() {
            $('#staff').html(LOADER);
        }

        /**
         * Append returned HTML to staff container
         * @param {string} html 
         */
        function appendStaffMembers(html) {
            $('#staff').html(html);
        }

        /**
         * Clear all selected paths from the map, select default values on the select element
         */
        function clearMap() {
            $('.region-active').removeClass('region-active')
            $('#start-route option[data-default="true"]').prop('selected', true);
            $('#end-route option[data-default="true"]').prop('selected', true);
        }


        // ## ## ##  ## ## ## //
        //        MAP         //
        // ## ## ##  ## ## ## //

        /**
         * Map clicking
         */

        // On path click
        $(document).on('click', '#dynamic-map-selector path', function (e) {

            // Get the ID of the path that was clicked
            let clickedPath = $(this).attr('id');

            // Get the selected option (START)
            let start = $('#start-route option:selected');

            // Get the map path ID from the selected option (START)
            let start_map = start.attr('data-map-path');

            // Get the selected option (DESTINATION)
            let destination = $('#end-route option:selected');

            // Get the map path ID from the selected option (DESTINATION)
            let destination_map = destination.attr('data-map-path');

            // If both select elements still have default values, the clicked path should be the starting point
            if (start_map === undefined && destination_map === undefined) {

                // Check all regions
                let multiple = false;
                $('#start-route option').each(function() {

                    let map_path = $(this).attr('data-map-path');
                    // If not undefined
                    if( map_path !== undefined ) {
                        let regions_in_route = map_path.split(',');

                        // Check if array (contains multiple) and length is more than 1
                        if( Array.isArray(regions_in_route) && regions_in_route.length > 1 ) {

                            // If the clicked path exists here
                            if( regions_in_route.includes(clickedPath) ) {
                                multiple = true;
                                $('#start-route option[data-map-path="' + map_path + '"]').prop('selected', true);
                            }

                        }
                    }
                });

                if( !multiple ) {
                    $('#start-route option[data-map-path=' + clickedPath + ']').prop('selected', true);
                }

                updateMap();
            } else if (start_map !== undefined && destination_map === undefined) {
                
                // If start select element has some value, then we are choosing/setting the destination
                // Check all regions
                let multiple = false;
                $('#end-route option').each(function() {

                    let map_path = $(this).attr('data-map-path');
                    // If not undefined
                    if( map_path !== undefined ) {
                        let regions_in_route = map_path.split(',');

                        // Check if array (contains multiple) and length is more than 1
                        if( Array.isArray(regions_in_route) && regions_in_route.length > 1 ) {

                            // If the clicked path exists here
                            if( regions_in_route.includes(clickedPath) ) {
                                multiple = true;
                                $('#end-route option[data-map-path="' + map_path + '"]').prop('selected', true);
                            }

                        }
                    }
                });

                if( !multiple ) {
                    $('#end-route option[data-map-path=' + clickedPath + ']').prop('selected', true);
                }

                updateMap();
            } else if (start_map !== undefined && destination_map !== undefined) {
                /**
                 * If both select elements are selected, this should be the starting point.
                 * Clear the map and select elements, and make this the starting point.
                 */
                clearMap();
                $('#start-route option[data-map-path=' + clickedPath + ']').prop('selected', true);
                updateMap();
            }

        });


        /**
         * Update active section on the map
         * @param {*} id 
         */
        function updateMap() {

            // Starting point
            let start = $('#start-route option:selected');
            // Destination
            let destination = $('#end-route option:selected');
            // Current category (ID)
            let categoryTermId = $('#category-title').attr('data-current-category');

            /** ---------------------------------------------- */

            // Clear all selected paths on the map
            $('.region-active').removeClass('region-active')

            // Get the current starting point ID on map
            let startMapIDs = start.attr('data-map-path');
            if(startMapIDs) {
                startMapIDs.split(",").forEach(mapPathID => {
                    $('#' + mapPathID).addClass('region-active');
                })
            }

            // Get the current destination point ID on map
            let destinationMapIDs = destination.attr('data-map-path');

            // Activate the starting point on the map
            $('#' + startMapIDs).addClass('region-active');

            // If destination is set, show it on the map also
            if (destinationMapIDs) {
                destinationMapIDs.split(",").forEach(mapPathID => {
                    $('#' + mapPathID).addClass('region-active');
                })
            }

            // Get the start point region ID
            let startValue = start.attr('value');
            // Get the start point region name
            let labelStart = start.html();

            // Get the destination point region ID
            let destinationValue = destination.attr('value');
            // Get the destination point region name
            let labelDestination = destination.html();


            // If both start and destination IDs are set, do a query
            if (startValue && destinationValue) {

                $.ajax({
                    url: page.admin_ajax,
                    dataType: 'json',
                    type: 'POST',
                    data: {
                        action: 'get_dynamic_staff',
                        starting_term_id: startValue,
                        destination_term_id: destinationValue,
                        label_start: labelStart,
                        label_destination: labelDestination,
                        category_term_id: categoryTermId
                    },
                    beforeSend: function () {
                        $('#staff-container').html(LOADER);
                    },
                    success: function (data) {
                        $('#staff-container').html(data.html);
                    }
                });
            }

        }


        // ## ## ## ## ## ##  ## ## //
        //      SELECT ELEMENTS     //
        // ## ## ##  ## ## ## ## ## //

        /**
         * On select change, update map
         */
        $(document).on('change', '.submittable', function () {
            updateMap();
        });



        // ## ## ## ## ## ## ## //
        //      SIDEMENU        //
        // ## ## ## ## ## ## ## //

        /**
         * Add click event listener to all list items on the sidemenu
         */
        $('.term-selector').on('click', function () {
            const termID = $(this).attr('data-term');
            get_staff(termID);
        });

        /**
         * Get staff members that belong to a specific category
         * @param {int} termID 
         */
        function get_staff(termID) {
            // Get all staff members for this category
            $.ajax({
                url: page.admin_ajax,
                dataType: 'json',
                type: 'POST',
                data: {
                    action: 'get_staff',
                    term_id: termID
                },
                beforeSend: function () {
                    spawnLoader();
                },
                success: function (data) {
                    appendStaffMembers(data.html)
                }
            });

        }


    }
});
